import React, {useState} from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './MessageTicket.css'
import RichTextEdit from '../RichTextEdit/RichTextEdit';

const MessageTicket = (props) => {
    const { user, ticket, setTicket, textoRes, setTextoRes, setFlagTextoRes } = props
    const [imageSizeErrors, setImageSizeErrors] = useState([])
    const [imageLimitWarning, setImageLimitWarning] = useState(null)

    return (
        <div className = 'col-8 richTextEditNM'>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={imageSizeErrors.length > 0} onClose={() => {setImageSizeErrors([])}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {imageSizeErrors.map((file, idx) => (
                        <div key={`${file.name}-${idx}`}>
                            {`El archivo "${file.name}" supera 5MB y se omitio.`}
                        </div>
                    ))}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!!imageLimitWarning} onClose={() => {setImageLimitWarning(null)}}>
                <Alert severity="warning" sx={{ width: '100%', justifyContent:'center' }}>
                    {imageLimitWarning
                        ? `Seleccionaste ${imageLimitWarning.selected} imagenes. Solo se cargaran las primeras ${imageLimitWarning.max}.`
                        : ""}
                </Alert>
            </Snackbar>
            <RichTextEdit
                contenido={textoRes}
                setContenido={setTextoRes}
                setFlagTextoRes={setFlagTextoRes}
                onImageSizeErrors={setImageSizeErrors}
                onImageSelectionWarning={setImageLimitWarning}
            />
        </div>
    )
}

export default MessageTicket;
